<template>
  <div>
    <HeaderComponent style="position:absolute;"/>
    <router-view />
    <FooterComponent />
  </div>
</template>

<script setup>
import HeaderComponent from "@/layout/page-header.vue";
import FooterComponent from "@/layout/page-bottom.vue";
</script>
